// extracted by mini-css-extract-plugin
module.exports = {"Loader":"spinner_Loader__3tvaX","load6":"spinner_load6__2Xg4U","round":"spinner_round__2j1CP"};